<template>
  <v-container v-if="masterId && RBAC_role_CAN_IMPERSONATE">
    <v-row>
      <v-col offset-md="3" md="6" cols="12">
        <base-material-card class="v-card-profile" :avatar="cardUserImage">
          <v-card-text class="text-center">
            <h4 class="display-2 font-weight-light mb-3">{{ fullName }}</h4>
            <h6 class="display-1 mb-1 grey--text">
              {{ $t(publicRole).toUpperCase() }}
            </h6>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn class="mx-5" @click="impersonate" color="success">{{
                  $t("impersonate_user")
                  }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "impersonate",
  props: {
    masterId: null,
  },
  data() {
    return {
      RBAC_role_CAN_IMPERSONATE: false,
      cardUserImage: "",
      publicRole: "",
      fullName: "",
    };
  },

  mounted() {
    this.loadData();
    this.RBAC_role_CAN_IMPERSONATE = this.checkUserRole(
      "role",
      "CAN_IMPERSONATE"
    );
  },
  methods: {
    loadData() {
      let _ = this;
      if (_.masterId)
        // Info utente
        this.chiamataAxios(
          "GET",
          "/auth/portal/getUserData/" + _.masterId
        ).then((response) => {
          _.cardUserImage = response.data.user.foto;
          _.publicRole = response.data.user.publicRole;
          _.fullName = response.data.user.fullName;
        });
    },
    impersonate: function (type, event) {
      let _ = this;
      _.chiamataAxios("POST", "/auth/portal/impersonate", {
        body: {
          masterId: _.masterId,
        },
      }).then((response) => {
        if (response.msg.esito) {
          // Recupero ruoli utente
          localStorage.setItem("authToken", response.data.token);
          _.chiamataAxios("GET", "/auth/portal/getUserRBAC").then(
            (response) => {
              let RBAC = {};
              response.data.RBAC.forEach((element) => {
                if (!RBAC[element.module]) RBAC[element.module] = {};
                if (!RBAC[element.module][element.code])
                  RBAC[element.module][element.code] = true;
              });
              let cryptToken = _.encryptCodes(JSON.stringify(RBAC));
              localStorage.setItem("rToken", cryptToken);
              window.location = "/#/portal";
            }
          );
        }
      });
    },
  },
  watch: {
    masterId: function (newVal, oldVal) {
      this.loadData();
    },
  },
};
</script>